<template>
  <div class="flex max-h-6 items-center rounded-full text-sm">
    <div
      class="rounded-l-full border-y-2 border-l-2 pr-1 pl-2"
      :class="[
        variantBorderMap[variant],
        variantBackgroundMap[variant],
        variantCategoryTextMap[variant],
      ]"
    >
      <slot name="category" />
    </div>
    <div
      class="rounded-r-full border-y-2 border-r-2 pr-2 pl-1"
      :class="[variantBorderMap[variant], variantTagTextMap[variant]]"
    >
      <slot name="tag" />
    </div>
  </div>
</template>
<script setup lang="ts">
type TagVariant = 'primary' | 'secondary' | 'tertiary' | 'quarternary';

withDefaults(defineProps<{ variant: TagVariant }>(), { variant: 'primary' });

const variantBackgroundMap: Record<TagVariant, string> = {
  primary: 'bg-primary-500',
  secondary: 'bg-secondary-500',
  tertiary: 'bg-tertiary-500',
  quarternary: 'bg-quarternary-500',
};

const variantBorderMap: Record<TagVariant, string> = {
  primary: 'border-primary-500',
  secondary: 'border-secondary-500',
  tertiary: 'border-tertiary-500',
  quarternary: 'border-quarternary-500',
};

const variantTagTextMap: Record<TagVariant, string> = {
  primary: 'text-primary-500',
  secondary: 'text-secondary-500',
  tertiary: 'text-tertiary-900',
  quarternary: 'text-quarternary-500',
};

const variantCategoryTextMap: Record<TagVariant, string> = {
  primary: 'text-white',
  secondary: 'text-neutral-900',
  tertiary: 'text-neutral-900',
  quarternary: 'text-quarternary-800',
};
</script>
